/*
 * サブシステム名：設定その他
 * 機能名：貨物日報データ取込確認
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'

export default {
  name: 'TohoKamotsuImportEdit',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
    },
    modeKengen: 0,
    errCheck: false,
    execMode: false,
    errorHeaders: [],
    errheader: {},
    errrows: [],
    errorCount: 0,
    showErrorList: false,
    // ページャーが表示されないためデフォルト100行表示を強制的に拡張
    customFooterProps: { 'items-per-page-options': [1000000] }
  }),
  components: {
    DdSubHeader,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable
  },
  computed: {
    filteredRows () {
      console.log('detail rows', this.rows)
      return this.rows.map((elem) => {
        return elem
      }).filter(function (elem) {
        return elem.gyousu > 0
      })
    },
    ...mapGetters({
    }),
    isLocal () {
      if (location.host === 'localhost:5001') {
        return true
      }
      return false
    },
    nowStatusCalced () {
      if (this.execMode === false) {
        return 'ログ参照'
      } else {
        if (this.errCheck === true) {
          return 'エラー'
        } else {
          return this.errCheck
        }
      }
    },
    isTorikomiButtonDisabled () {
      // エラーフラグがNGの場合に非活性
      if (this.errCheck === true || this.execMode === false) {
        this.showErrorList = true
        return false
      }
      this.showErrorList = false
      return true
    }
  },
  created () {
    console.log('start', this.$route.params)
    this.id = Number(this.$route.params.id)
    if (isNaN(this.id)) {
      this.id = 0
    }
    if (Number(this.$route.params.edit) === 1) {
      this.execMode = true
    } else {
      this.execMode = false
    }
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        defineHeaderPromise: () => {
          // エラー詳細ヘッダー取得
          return new Promise(resolve => {
            this.HttpClient
              .get(`/api/v1/trImportHistoryKihon/find?id=${self.id}`)
              .then((data) => {
                self.errheader = data.payload
                self.errorHeaders = [
                  { text: 'エラー行数', value: 'errGyousu', width: '300px' },
                  { text: 'エラーメッセージ', value: 'errMsg' }
                ]
                console.log('error header', self.errheader)
                resolve()
              })
          }).then(() => {
            // エラー詳細を取得
            return new Promise(resolve => {
              this.HttpClient
                .post('/api/v1/TrImportHistoryDetail/search', { TrImportHistoryKihonId: self.errheader.id })
                .then((data) => {
                  self.errrec = data.payload
                  if (self.errrec.length > 0) {
                    var DetailList = []
                    var DetailData = {}
                    self.errrec.forEach(function (item) {
                      DetailData = {}
                      // エラー判定
                      if (item.errorFlg === true) {
                        // 行数
                        DetailData.errGyousu = item.importRowNo
                        // エラーメッセージ
                        DetailData.errMsg = item.errorMsg
                        DetailList.push(DetailData)
                      }
                    })
                    self.errrows = DetailList
                  } else {
                    const errMsgList = [{
                      errGyosu: '',
                      errMsg: self.errheader.errorMsg
                    }]
                    self.errrows = errMsgList
                  }
                  console.log('error rowlist', self.errrows)
                  self.errorCount = self.errheader.errorRowCnt
                  resolve()
                })
            })
          }).then(() => {
            // 取込一覧ヘッダー取得
            return new Promise((resolve) => {
              this.HttpClient
                .post('/api/v1/MstFileFormatDetail/search', { fileFormatCd: self.errheader.fileFormatCd.trim() })
                .then((data) => {
                  self.trheader = data.payload
                  var headerList = []
                  var headerData = {}
                  headerData = {}
                  headerData.text = '行数'
                  headerData.value = 'gyousu'
                  headerList.push(headerData)
                  headerData = {}
                  headerData.text = 'エラーフラグ'
                  headerData.value = 'errorFlg'
                  headerList.push(headerData)
                  // 可変列取得
                  self.trheader.forEach(function (item) {
                    headerData = {}
                    headerData.text = item.itemComment
                    headerData.value = 'key_' + item.columnOrder
                    headerList.push(headerData)
                  })
                  self.headers = headerList
                  resolve()
                })
            })
          }).then(() => {
            // 取込一覧を取得
            return new Promise(resolve => {
              self.HttpClient
                .post('/api/v1/TrImportHistoryDetail/search', { TrImportHistoryKihonId: self.errheader.id })
                .then((data) => {
                  self.rec = data.payload
                  console.log('detail rows l', data.payload)

                  var detailList = []
                  var detailNGList = []
                  var detailData = {}
                  var gyou = 1
                  self.rec.forEach(function (item) {
                    if (gyou !== item.importRowNo) {
                      if (self.errCheck === true) {
                        detailNGList.push(detailData)
                      } else {
                        detailList.push(detailData)
                      }
                      detailData = {}
                      self.errCheck = false
                    }
                    if (item.errorFlg === true) {
                      self.errCheck = true
                    }
                    detailData.gyousu = item.importRowNo
                    if (self.errCheck === true) {
                      detailData.errorFlg = 'NG'
                    } else {
                      detailData.errorFlg = ''
                    }
                    // 可変列取得
                    detailData['key_' + item.columnOrder] = item.itemValue
                    gyou = item.importRowNo
                  })
                  if (self.rec.length > 0) {
                    if (self.errCheck === true) {
                      detailNGList.push(detailData)
                    } else {
                      detailList.push(detailData)
                    }
                  }
                  if (self.errrows.length > 0 || self.rec.length === 0) {
                    self.errCheck = true
                  } else {
                    self.errCheck = false
                  }
                  console.log('detail rows 1', detailList)
                  console.log('detail rows N', detailNGList)
                  console.log('error info', self.errrows.length, self.rec.length, self.errCheck)
                  detailList = detailNGList.concat(detailList)
                  self.rows = detailList
                  console.log('detail rows s', self.rows)
                  resolve()
                })
            })
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onTorikomiButtonClick: function (e) {
      console.log(e)
      const self = this
      self.Effects.loadStart()
      self.HttpClient
        .put(`/api/v1/Thulp0020/Exec?id=${self.id}`)
        .then((data) => {
          console.log('retdata', data)
          if (data.isValid) {
            self.transition(0, { id: self.id, edit: 0 })
          } else {
            self.setSummaryMessage(data.summaryMessage)
            self.Effects.loadComplete()
          }
        }).catch((e) => {
          console.log('error', e)
          var edata = {
            message: e.message,
            messageCd: ''
          }
          self.setSummaryMessage(edata)
          self.Effects.loadComplete()
        })
    },
    itemRowBackground (item) {
      return item.errorFlg === 'NG' ? 'cellBackgroundColorRed' : 'cellBackgroundColorWhite'
    }
  }
}
